<nz-modal
  [(nzVisible)]="visible"
  [nzTitle]="notification?.title || 'Chi tiết thông báo'"
  (nzOnCancel)="close()"
  [nzFooter]="null"
  nzCentered
  nzWidth="800px"
  nzWrapClassName="notification-detail-modal">
  <ng-container *nzModalContent>
    <div class="notification-detail" *ngIf="notification">
      <div class="notification-detail__meta" *ngIf="notification.createdTime">
        <span nz-icon nzType="clock-circle" nzTheme="outline"></span>
        {{ notification.createdTime }}
      </div>
      <div
        class="notification-detail__content notification-content-view"
        [innerHTML]="notification.content">
      </div>
      <button
        *ngIf="notification.attachmentFileName"
        nz-button
        nzType="link"
        type="button"
        class="notification-detail__attachment"
        (click)="downloadAttachment()">
        <span nz-icon nzType="paper-clip" nzTheme="outline"></span>
        {{ notification.attachmentFileName }}
      </button>
    </div>
  </ng-container>
</nz-modal>
